(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 394:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(1635);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9563);
/* harmony import */ var components_Logo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9213);
/* harmony import */ var _ErrorTemplate_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3786);
/* harmony import */ var _ErrorTemplate_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ErrorTemplate_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_getCurrentSiteBusinessUnit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6810);








function ErrorTemplate(param) {
    var title = param.title, description = param.description;
    var currentSite = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .SitesContext */ .y).currentSite;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_ErrorTemplate_module_css__WEBPACK_IMPORTED_MODULE_5___default().container),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: (_ErrorTemplate_module_css__WEBPACK_IMPORTED_MODULE_5___default().logo),
                colour: "#fff",
                businessUnit: (0,_helpers_getCurrentSiteBusinessUnit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_ErrorTemplate_module_css__WEBPACK_IMPORTED_MODULE_5___default().info),
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            "Go to the",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: currentSite === null || currentSite === void 0 ? void 0 : currentSite.path,
                                children: "homepage"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
ErrorTemplate.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
ErrorTemplate.defaultProps = {
    title: "",
    description: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorTemplate);


/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Custom404; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_ErrorTemplate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8019);


function Custom404() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ErrorTemplate__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        title: "Page Not Found",
        description: "It might be an old link or the page has moved"
    });
}


/***/ }),

/***/ 3786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ErrorTemplate_spacing--xxxs__Znydn","spacing--xxs":"ErrorTemplate_spacing--xxs__QMAeT","spacing--xs":"ErrorTemplate_spacing--xs__JzLmk","spacing--sm":"ErrorTemplate_spacing--sm__XAtVX","spacing--md":"ErrorTemplate_spacing--md__3O7Yy","spacing--lg":"ErrorTemplate_spacing--lg__wlUpw","spacing--xl":"ErrorTemplate_spacing--xl__7Mk0j","spacing--xxl":"ErrorTemplate_spacing--xxl__FTMAf","spacing--xxxl":"ErrorTemplate_spacing--xxxl__r3juc","container":"ErrorTemplate_container__6YBVr","logo":"ErrorTemplate_logo__3uxrm","info":"ErrorTemplate_info__9CvsS","fadeInItems":"ErrorTemplate_fadeInItems__pJuzC"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(394); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);